import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import {
	setupForegroundMessageListener,
	tryRegisterFcmTokenSilently,
} from "../utilities/firebaseMessaging";
import {
	dispatchNotificationsUpdated,
	markNotificationAsRead,
} from "./useNotifications";

export function useFirebaseMessaging() {
	const navigate = useNavigate();

	useEffect(() => {
		tryRegisterFcmTokenSilently();

		const handleNotificationNavigate = async (url, notificationId) => {
			if (notificationId) {
				try {
					await markNotificationAsRead(notificationId);
				} catch (error) {
					console.error(
						"Error marking notification as read from FCM:",
						error,
					);
				}
			}
			if (url) {
				navigate(url);
			}
		};

		const onServiceWorkerMessage = (event) => {
			if (event.data?.type === "NOTIFICATION_NAVIGATE") {
				handleNotificationNavigate(
					event.data.url,
					event.data.notificationId,
				);
			}
		};

		navigator.serviceWorker?.addEventListener(
			"message",
			onServiceWorkerMessage,
		);

		const unsubscribe = setupForegroundMessageListener((payload) => {
			const data = payload.data || {};
			const notificationPayload = payload.notification || {};
			const title =
				data.title || notificationPayload.title || "알림";
			const body = data.body || notificationPayload.body;

			dispatchNotificationsUpdated();

			notification.info({
				message: title,
				description: body,
				placement: "topRight",
				onClick: () =>
					handleNotificationNavigate(
						data.url,
						data.notification_id,
					),
			});
		});

		return () => {
			unsubscribe();
			navigator.serviceWorker?.removeEventListener(
				"message",
				onServiceWorkerMessage,
			);
		};
	}, [navigate]);
}
